// src/components/admin/AdminAlertBanner.js
import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { COLORS } from '../../styles/tokens';

/**
 * Viser en vedvarende banner hvis det finnes uløste adminAlerts for en entitet (userId eller orderId).
 */
export default function AdminAlertBanner({ entityId }) {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    if (!entityId) return;
    getDocs(
      query(collection(db, 'adminAlerts'), where('userId', '==', entityId), where('resolvedAt', '==', null))
    ).then(snap => setAlerts(snap.docs.map(d => ({ id: d.id, ...d.data() }))))
     .catch(e => console.error('AdminAlertBanner fetch failed:', e));
  }, [entityId]);

  if (!alerts.length) return null;

  return (
    <div style={{ background:COLORS.warningBg, border:`1px solid ${COLORS.warningBorder}`, borderRadius:6, padding:'10px 14px', marginBottom:16, fontSize:13 }}>
      <strong>OBS:</strong> {alerts.length} uløst(e) varsler for denne brukeren.
      {alerts.map(a => (
        <div key={a.id} style={{ marginTop:4, color:COLORS.warningText }}>
          · {a.type}: {a.error ?? ''}
        </div>
      ))}
    </div>
  );
}
